var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckiconAmarelo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0C18.0039 0 19.25 1.24609 19.25 2.75V16.5C19.25 18.0469 18.0039 19.25 16.5 19.25H2.75C1.20312 19.25 0 18.0469 0 16.5V2.75C0 1.24609 1.20312 0 2.75 0H16.5ZM14.5664 7.73438C15.0391 7.26172 15.0391 6.53125 14.5664 6.05859C14.0938 5.58594 13.3633 5.58594 12.8906 6.05859L8.25 10.6992L6.31641 8.80859C5.84375 8.33594 5.11328 8.33594 4.64062 8.80859C4.16797 9.28125 4.16797 10.0117 4.64062 10.4844L7.39062 13.2344C7.86328 13.707 8.59375 13.707 9.06641 13.2344L14.5664 7.73438Z",
    fill: "#DFA242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckiconAmarelo);
export default __webpack_public_path__ + "static/media/checkicon_amarelo.237e13f238210b1b6bbe6e7db4be52ea.svg";
export { ForwardRef as ReactComponent };